'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAvailabilityTypicalResponseTimeMessage = undefined;

var _reselect = require('reselect');

var _makeTypicalResponseTimeText = require('conversations-schema/typical-response-time/operators/makeTypicalResponseTimeText');

var _getTypicalResponseTime = require('conversations-schema/availability/operators/getTypicalResponseTime');

var _getWidgetAvailabilityOptions = require('./getWidgetAvailabilityOptions');

var getAvailabilityTypicalResponseTimeMessage = exports.getAvailabilityTypicalResponseTimeMessage = (0, _reselect.createSelector)(_getWidgetAvailabilityOptions.getWidgetAvailabilityOptions, function (availabilityOptions) {
  var typicalResponseTime = (0, _getTypicalResponseTime.getTypicalResponseTime)(availabilityOptions);

  if (!typicalResponseTime) {
    return '';
  }

  return (0, _makeTypicalResponseTimeText.makeTypicalResponseTimeText)({ typicalResponseTime: typicalResponseTime });
});


//////////////////
// WEBPACK FOOTER
// ./js/availability/selectors/getAvailabilityTypicalResponseTimeMessage.js
// module id = 259
// module chunks = 2 3